'use client';

import { useState, createContext } from 'react';

import { createLocalisationConfigContext } from '../services/config';
import type { LocalisationConfigContextType, LocalisationConfig } from '../types';

export const LocalisationConfigContext = createContext<LocalisationConfigContextType | null>(null);

export function LocalisationConfigProvider({
  children,
  config,
}: Readonly<{
  children: React.ReactNode;
  config: LocalisationConfig;
}>) {
  const [localisationConfigContext] = useState(() => createLocalisationConfigContext(config));

  return (
    <LocalisationConfigContext.Provider value={localisationConfigContext}>
      {children}
    </LocalisationConfigContext.Provider>
  );
}
